import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { setZodErrorMap } from './zodErrorMap';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'de', 'ru'],

    detection: {
      order: ['path', 'localStorage', 'cookie', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: ['common', 'auth', 'campaigns', 'teams', 'subscriptions', 'dashboard', 'validation', 'toasts', 'admin', 'profile', 'account_settings', 'faq', 'referrals', 'marketing', 'pricing', 'legal', 'contact', 'blog', 'about', 'privacy', 'terms', 'cookies', 'bans', 'demo', 'trafficQuality'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },
  });

// Set global Zod error map for translated validation messages
setZodErrorMap();

export default i18n;
